<template>
    <div class="assignment-results">
        <design-2021-group-results-part-component
            v-for="part in parts"
            :key="part.id"
            :part-in="part">
        </design-2021-group-results-part-component>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-group-assignment-results-component',
        props: {
            assignmentIn: {
                type: Object,
            }
        },
        computed: {
            parts() {
                let parts = [];
                this.assignmentIn.sub_assignments.sort((a, b) => a.order - b.order).forEach((subAssignment) => {
                    subAssignment.pages.sort((a, b) => a.order - b.order).forEach((page) => {
                        page.parts.sort((a, b) => a.order - b.order).forEach((part) => {
                            parts.push(part);
                        })
                    })
                })

                return parts;
            }
        }
    };
</script>

<style scoped lang="scss">

</style>